import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import reviewers from './reviewers.json';
import reviewersBooster from './reviewers-booster.json';
import {OneMonthFreeMode} from "../../one-month-free.component";
import {UserSubscription} from "../../../../../../user/user-subscription";

@Component({
    selector: 'db-one-month-free-checkout-info',
    templateUrl: './one-month-free-checkout-info.component.html',
    styleUrls: ['./one-month-free-checkout-info.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class OneMonthFreeCheckoutInfoComponent implements OnInit {

  @Input() mode: OneMonthFreeMode;
  @Input() expirationDate: string;
  @Input() currentSubscription: UserSubscription;
  public reviewers;

  ngOnInit() {
    this.reviewers = this.currentSubscription && this.currentSubscription.trialBoosterClient ? reviewersBooster : reviewers;
  }

}
